import { computed, inject, type Ref } from 'vue';
import type { SerializedUser } from '@/api/users';

export type LatLng = { lat: number; lng: number };

// Frames a whole country: the zoom for maps that have nothing more specific to show yet.
export const COUNTRY_ZOOM = 6;
const WORLD_CENTER: LatLng = { lat: 0, lng: 0 };

// Centroid of the company's country, the resting position for maps without coordinates.
export function useCompanyMapCenter() {
  const currentUser = inject<Ref<SerializedUser | undefined>>('currentUser');

  return computed<LatLng>(() => currentUser?.value?.companyMapCenter ?? WORLD_CENTER);
}
